export default "__VITE_ASSET__BZT9GTDk__"